import { Price } from '@model/common';

export enum OfferType {
  ALL_INCLUSIVE = 'all-inclusive',
  NO_SINGLE_SUPPLEMENT = 'no-single-supplement',
  SECOND_WEEK_FREE = '2nd-week-free',
  THIRD_WEEK_FREE = '3rd-week-free',
  BLACK_FRIDAY_HOLIDAYS = 'black-friday-holidays',
  BLACK_FRIDAY_TOURS = 'black-friday-tours',
  NEWSPAPER_OFFERS = 'newspaper-offers',
  ESCORTED_TOUR_OFFERS = 'escorted-tours'
}

export interface OffersResponse<T> {
  data: Array<T>;
}

export interface OffersDestination {
  name: string;
  path: string;
  hotels: number;
  cheapestPrice: Price;
}

export interface OffersDestinationWithImage extends OffersDestination {
  images: Array<string>;
}

export const offerTypesList: Array<OfferType> = [
  OfferType.ALL_INCLUSIVE,
  OfferType.NO_SINGLE_SUPPLEMENT,
  OfferType.SECOND_WEEK_FREE,
  OfferType.THIRD_WEEK_FREE
];

export const offerDescriptionFieldMapper: any = {
  [OfferType.ALL_INCLUSIVE]: 'descriptionAllInclusive',
  [OfferType.NO_SINGLE_SUPPLEMENT]: 'descriptionNoSingleSupplement',
  [OfferType.SECOND_WEEK_FREE]: 'descriptionSecondWeekFree',
  [OfferType.THIRD_WEEK_FREE]: 'descriptionThirdWeekFree'
};

export const OfferIcons = {
  'all-inclusive': 'mhi-meal',
  'no-single-supplement': 'mhi-person',
  '2nd-week-free': 'mhi-value',
  '3rd-week-free': 'mhi-value',
  'newspaper-offers': 'mhi-holidays',
  'escorted-tours': 'mhi-tours'
};
